import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';

import { useAppInformation } from 'features/app-information/hooks';
import styles from 'features/app-information/views/app-information-view.module.scss';
import ExternalLink from 'features/app-information/views/components/external-link.component';
import FeatureFlagList from 'features/app-information/views/components/feature-flag-list.component';

function AppInformation(): ReactElement {
  const { t } = useTranslation('appInformation');
  const { tenantName, appVersion, environment, shouldShowFeatureFlags, isProduction } = useAppInformation();

  const shouldShowEnvironment = environment && !isProduction;

  return (
    <div className={styles.appInformationContainer}>
      <Typography variant="h3">{t('title')}</Typography>
      <div className={styles.companyContainer}>
        <Typography variant="h5">{t('company')}</Typography>
        <Typography variant="h4">{tenantName ?? ''}</Typography>
      </div>

      <div className={styles.versionContainer}>
        <Typography variant="h5">{t('version')}</Typography>
        <div className={styles.version}>
          <Typography variant="h4">{t('appName')}</Typography>
          <Typography variant="body1">{appVersion}</Typography>
          {shouldShowEnvironment && environment && <Typography variant="body1">{t(`environment.${environment}`)}</Typography>}
        </div>
      </div>

      <div className={styles.privacyAndTermsContainer}>
        <Typography variant="h5">{t('privacyAndTerms')}</Typography>
        <ExternalLink
          link="https://www.sonevo.nl/privacystatement"
          linkTranslationKey={t('privacyPolicy')}
          linkCompanyTranslationKey={t('sonevocloud')}
        />
      </div>

      {shouldShowFeatureFlags && <FeatureFlagList />}
    </div>
  );
}

export default AppInformation;
